import React from "react";
import {
  FaBars,
  FaHome,
  FaTrophy,
  FaScroll,
  FaListOl,
  FaBook
} from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Header = ({ logo, menuOpen, setMenuOpen, idleague }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    {
      name: "WH40k League",
      icon: FaHome,
      link: `/wh40k?idleague=${idleague}`,
      match: "/wh40k"
    },
    {
      name: "Leaderboard",
      icon: FaListOl,
      link: `/leaderboardv2?idleague=${idleague}`,
      match: "/leaderboardv2"
    },
    {
      name: "Honors",
      icon: FaTrophy,
      link: `/honor?idleague=${idleague}`,
      match: "/honor"
    },
    {
      name: "Chronicles",
      icon: FaScroll,
      link: `/wh40k/chronicles?idleague=${idleague}`,
      match: "/wh40k/chronicles"
    },
    {
      name: "Rules",
      icon: FaBook,
      link: `#`,
      match: "/rules"
    }
  ];

  return (
    <header className="bg-gray-800 p-4 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <img src={logo} alt="Logo" className="w-10 h-10 rounded-full" />
          <h1 className="text-2xl font-bold">
            El Cobrador League - Warhammer 40k
          </h1>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="lg:hidden text-white"
        >
          <FaBars size={24} />
        </button>

        <nav className={`lg:flex space-x-4 ${menuOpen ? "block" : "hidden"}`}>
          {menuItems.map((item, index) => {
            const isActive =
              item.match === "/wh40k"
                ? currentPath === "/wh40k"
                : currentPath.startsWith(item.match);

            return (
              <a
                key={index}
                href={item.link}
                className={`
                  flex items-center space-x-1 transition duration-200 px-2 py-1 rounded
                  ${
                    isActive
                      ? "text-white bg-red-700 font-semibold"
                      : "text-gray-300 hover:text-white hover:bg-gray-700"
                  }
                `}
              >
                <item.icon className="inline-block mr-1" />
                <span>{item.name}</span>
              </a>
            );
          })}
        </nav>
      </div>
    </header>
  );
};

export default Header;
